import { render, staticRenderFns } from "./BeaconId.vue?vue&type=template&id=2b4cfd4a&scoped=true&"
import script from "./BeaconId.vue?vue&type=script&lang=js&"
export * from "./BeaconId.vue?vue&type=script&lang=js&"
import style0 from "./BeaconId.vue?vue&type=style&index=0&id=2b4cfd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4cfd4a",
  null
  
)

export default component.exports